<template>
  <div class="ppc1">
    <Header :title="title"></Header>
    <section class="hero is-small">
      <div class="hero-body">
        <div class="container level">
        <div class="field">
          <div class="control">
            <p class="title is-size-5 level-item"> {{ this.today | moment("dddd, MMMM Do YYYY") }} </p>
          </div>
        </div>

<!-- <div class="dropdown is-active is-right is-hoverable"> -->
<div class="dropdown is-right is-hoverable">
  <div class="dropdown-trigger">
    <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
      <span>Options</span>
      <span class="icon is-small">
        <i class="fas fa-angle-down" aria-hidden="true"></i>
      </span>
    </button>
  </div>
  <div class="dropdown-menu" id="dropdown-menu" role="menu">
    <div class="dropdown-content">
          <a class="dropdown-item" @click="closeRate">Close rate CHECK</a>
          <a class="dropdown-item" @click="acquiredPlus(0.5)">acquiredPlus</a>
          <a class="dropdown-item" @click="conversionsPlus(0.5)">NUM OF CONVERSIONS</a>
          <a class="dropdown-item" @click="costPerConversionPlus">costperconversionplus</a>
          <a class="dropdown-item" @click="closeRateTen">Close rate: 10% - Low</a>
          <a class="dropdown-item" @click="closeRateTwenty">Close rate: 20% - Typical</a>
          <a class="dropdown-item" @click="closeRateThirty">Close rate: 30% - Best in class</a>
          <hr class="dropdown-divider">
          <a class="dropdown-item" @click="closeRateEcommerce">Industry: E-commerce</a>
          <!-- <a class="dropdown-item" @click="closeRateEnterprise">Industry: Enterprise</a> -->
          <hr class="dropdown-divider">
          <a class="dropdown-item" @click="agencyFeesIncluded = !agencyFeesIncluded"> <span v-show="agencyFeesIncluded">Exclude agency cost</span> <span v-show="!agencyFeesIncluded">Include agency cost</span></a>
          <hr class="dropdown-divider">
          <a class="dropdown-item" @click="resetValues">Reset values</a>
          <a class="dropdown-item" @click="dummyValues">Dummy values</a>
    </div>
  </div>
</div>

        </div>
      </div>
    </section>

<section class="container">

<div class="tile is-ancestor">
  <div class="tile is-parent">
    <article class="tile is-child box">

<h2 class="title is-size-4">
            Your goals
          </h2>
          <div class="columns">
            <div class="column">
            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="How many leads would you like per month?">Total leads per month
               <!-- <span class="icon" @click="showModal">
                  <i class="fas fa-question-circle"></i>
              </span> -->
                </label>
            </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money class="input" :leadsPerMonth="leadsPerMonth" v-bind="numberWhole" v-model="leadsPerMonth" ></money>
                  </div>
                  <p v-if="leadsPerMonth !== 0" class="annual-spend">{{ formatNumberOnly(leadsPerMonth * 12) }} leads annually</p>
                </div>
              </div>
            </div>


          <div class="colum">
            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Total amount you are willing to pay per lead. Play around with numbers.">Total cost per lead</label>
              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <!-- <money class="input" v-bind="moneyNoDecimal" v-model="costPerClick"></money> -->
                    <money class="input" v-bind="moneyNoDecimal"></money>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>

          <div class="column">
            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="How many sales are you looking for each month?">Total sales per month
                  <!-- <span class="icon" @click="showModalConversion">
                    <i class="fas fa-question-circle"></i>
                  </span> -->
                </label>

              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <!-- <money class="input" v-bind="numberWhole" v-model="conversionRate"></money> -->
                    <money class="input" v-bind="numberWhole"></money>
                  </div>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="What is the cost of the product you sell?">How much you sell for?
                  <!-- <span class="icon" @click="showModalConversion">
                    <i class="fas fa-question-circle"></i>
                  </span> -->
                </label>

              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <!-- <money class="input" v-bind="moneyNoDecimal" v-model="conversionRate"></money> -->
                    <money class="input" v-bind="moneyNoDecimal"></money>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


    </article>
  </div>
</div>

<div class="tile is-ancestor has-text-centered">
                        <div class="tile is-parent">
                            <article class="tile is-child box">

<h2 class="title is-size-4">
            Keyword metrics from Google Ads
          </h2>
            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Search data from Google Ads">Monthly searches
               <!-- <span class="icon" @click="showModal">
                  <i class="fas fa-question-circle"></i>
              </span> -->
                </label>
            </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money class="input" :monthlySearches="monthlySearches" v-bind="numberWhole" v-model="monthlySearches" ></money>
                  </div>
                  <p v-if="monthlySearches !== 0" class="annual-spend">{{ formatNumberOnly(monthlySearches * 12) }} searches annually</p>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="The percentage who click on a Google Ad.">Expected CTR</label>
              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money class="input" v-bind="percent" v-model="clickThroughRate"></money>
                  </div>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Visits to your website from ads.">Website sessions</label>
              </div>
              <div class="column">
                    <p v-if="clickThroughRate !== 0"> {{ formatNumberOnly(websiteVisits) }} sessions</p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="How many sales are you looking for each month?">Average CPC
                  <!-- <span class="icon" @click="showModalConversion">
                    <i class="fas fa-question-circle"></i>
                  </span> -->
                </label>

              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money class="input" v-bind="money" v-model="costPerClick"></money>
                  </div>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Visits to your website from ads.">Estimated monthly spend</label>
              </div>
              <div class="column">
                    <!-- <p v-if="costPerClick !== 0"> {{ formatNumberOnly(websiteVisits) }}</p> -->
                    <p v-if="costPerClick !== 0"> {{ formatNumber(websiteVisits * costPerClick) }}</p>
              </div>
            </div>

                            </article>
                        </div>
                        <div class="tile is-parent">
                            <article class="tile is-child box">


<h3 class="title is-size-4">
            Lead and sales metrics
          </h3>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage of leads that receive a response.">Website conversion rate</label>
              </div>
              <div class="column">
                  <div class="control">
                    <money class="input" v-bind="percent" v-model="conversionRate"></money>
                    <!-- <p>
                      <span v-if="percentageResponse !== 0 && conversionRate !== 0"> {{ formatNumberOnly(qualityLeads) }} leads </span>
                    </p> -->
                  </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Visits to your website from ads.">Cost per lead</label>
              </div>
              <div class="column">
                    <p v-if="costPerClick !== 0"> £{{ formatNumber(costPerLead) }}</p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage of leads that receive a response.">Sales close rate</label>
              </div>
              <div class="column">
                  <div class="control">
                    <money class="input" v-bind="percentNoDecimal" v-model="salesCloseRate"></money>
                    <!-- <p>
                      <span v-if="percentageResponse !== 0 && conversionRate !== 0"> {{ formatNumberOnly(qualityLeads) }} leads </span>
                    </p> -->
                  </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Visits to your website from ads.">Average cost per sale</label>
              </div>
              <div class="column">
                    <p v-if="salesClostRate !== 0"> {{ formatNumberOnly(averageCostPerSale) }} sessions</p>
              </div>
            </div>

<!-- <h3 class="title is-size-4">
            Potential
          </h3> -->

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Visits to your website from ads.">Leads</label>
              </div>
              <div class="column">
                    <p v-if="costPerClick !== 0"> {{ formatNumberOnly(leadsPerMonth) }} leads</p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Visits to your website from ads.">Sales</label>
              </div>
              <div class="column">
                    <p v-if="costPerClick !== 0"> {{ formatNumberOnly(salesPerMonth) }} sales</p>
              </div>
            </div>
                            </article>
                        </div>

                    </div>
</section>

  <Footer></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header'
import {Money} from 'v-money'
import Footer from '@/components/Footer'

var moment = require('moment')

export default {
  name: 'PPC1',
  components: {
    Header,
    Money,
    Footer
  },
  data () {
    return {
      title: 'PPC suitability',
      moment: moment,
      today: new Date(),
      month1: this.today | moment("MMM"),
      leadsPerMonth: '',
      clickThroughRate: '',
      adSpend: '',
      agencyCost: '',
      agencyFeesIncluded: false,
      testValue: 99,
      costPerClick: '',
      conversionRate: '',
      percentageResponse: 0,
      percentageProposals: '',
      percentageAcquired: '',
      dealSize: '',
      margin: '',
      isActive: false,
      money: {
        // The character used to show the decimal place.
        decimal: '.',
        // The character used to separate numbers in groups of three.
        thousands: ',',
        // The currency name or symbol followed by a space.
        prefix: '£',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '',
        // Level of decimal precision. REQUIRED
        precision: 2,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false
      },
      moneyNoDecimal: {
        // The character used to show the decimal place.
        decimal: '.',
        // The character used to separate numbers in groups of three.
        thousands: ',',
        // The currency name or symbol followed by a space.
        prefix: '£',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '',
        // Level of decimal precision. REQUIRED
        precision: 0,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false
      },
      numberWhole: {
        // The character used to show the decimal place.
        decimal: '',
        // The character used to separate numbers in groups of three.
        thousands: ',',
        // The currency name or symbol followed by a space.
        prefix: '',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '',
        // Level of decimal precision. REQUIRED
        precision: 0,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false
      },
      percent: {
        // The character used to show the decimal place.
        decimal: '.',
        // The character used to separate numbers in groups of three.
        thousands: '',
        // The currency name or symbol followed by a space.
        prefix: '',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '%',
        // Level of decimal precision. REQUIRED
        precision: 2,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false
      },
      percentNoDecimal: {
        // The character used to show the decimal place.
        decimal: '.',
        // The character used to separate numbers in groups of three.
        thousands: '',
        // The currency name or symbol followed by a space.
        prefix: '',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '%',
        // Level of decimal precision. REQUIRED
        precision: 0,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false
      },
      // instantiating datacollection with null
      datacollection: null
    }
  },
  computed: {
    date: function () {
      return this.today.getFullYear()+'-'+(this.today.getMonth()+1)+'-'+this.today.getDate()
    },
    websiteVisits: function () {
      return this.monthlySearches * this.clickThroughRate / 100
    },
    conversions: function () {
      return ((this.adSpend / this.costPerClick) * this.conversionRate) / 100
    },
    costPerConversion: function () {
      return (this.adSpend + this.agencyCost) / this.conversions
    },
    qualityLeads: function () {
      return (this.conversions * this.percentageResponse) / 100
    },
    proposals: function () {
      return (this.qualityLeads * this.percentageProposals) / 100
    },
    acquired: function () {
      return (this.proposals * this.percentageAcquired) / 100
    },
    netRevenue: function () {
      return (this.dealSize * this.margin) / 100
    },
    costPerSale: function () {
      return (this.adSpend + this.agencyCost) / this.acquired
    },
    returnOnPaidInvestment: function () {
      return ((this.netRevenue - this.costPerSale) / this.costPerSale) * 100
    },
    profit: function () {
      return (this.netRevenue - this.costPerSale) * this.acquired
    }
  },
  created () {
  // anytime the vue instance is created, call the fillData() function.
    this.fillData()
  },
  methods: {
    conversionsPlus: function (cr) {
      let newConversions = ((this.adSpend / this.costPerClick) * (this.conversionRate + cr)) / 100
      console.log('newConversions: ' + newConversions)
      return newConversions
    },
    costPerConversionPlus: function () {
      let newcpcp = (this.adSpend + this.agencyCost) / this.conversionsPlus(0.5)

      console.log('costperconversionplus: ' + newcpcp)
    },
    qualityLeadsPlus: function (x) {
      let qlp = (this.conversionsPlus(x) * this.percentageResponse) / 100
      console.log('qlp: ' + qlp)

      return qlp

    },
    proposalsPlus: function (x) {
      return (this.qualityLeadsPlus(x) * this.percentageProposals) / 100
    },
    acquiredPlus: function (x) {
      let ap = (this.proposalsPlus(x) * this.percentageAcquired) / 100
      console.log('ap: ' + ap)
      return ap
    },
    closeRate () {
      var crate = (this.percentageResponse / 100) * (this.percentageProposals / 100) * (this.percentageAcquired / 100)
      console.log('closeRate: ' + crate) // E.G. O.2
      return crate
    },
    formatNumber (num) {
      num = Math.round(num)
      return "£" + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    formatNumberOnly (num) {
      num = Math.round(num)
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    toggle () {
      this.isActive = !this.isActive
    },
    showModal () {
      let element = document.getElementById('modal')
      element.classList.add('is-active')
    },
    showModalConversion () {
      let element = document.getElementById('modal-conversion')
      element.classList.add('is-active')
    },
    resetValues () {
      this.adSpend = 0
      this.agencyCost = 0
      this.costPerClick = 0
      this.conversionRate = 0
      this.percentageResponse = 0
      this.percentageProposals = 0
      this.percentageAcquired = 0
      this.dealSize = 0
      this.margin = 0
    },
    qualityLeadsSetter () {
      this.qualityLeads = 43
    },
    dummyValues () {
      this.adSpend = 8000
      this.agencyCost = 0
      this.costPerClick = 4.50
      this.conversionRate = 4.00
      this.percentageResponse = 66
      this.percentageProposals = 67
      this.percentageAcquired = 67
      this.dealSize = 9000
      this.margin = 10
    },
    closeRateTen () {
      this.percentageResponse = 50
      this.percentageProposals = 50
      this.percentageAcquired = 40
    },
    closeRateTwenty () {
      this.percentageResponse = 50
      this.percentageProposals = 50
      this.percentageAcquired = 80
    },
    closeRateThirty () {
      this.percentageResponse = 75
      this.percentageProposals = 66.6
      this.percentageAcquired = 60
    },
    closeRateEcommerce () {
      this.percentageResponse = 100
      this.percentageProposals = 100
      this.percentageAcquired = 100
    },
    // closeRateEnterprise () {
    //   this.percentageResponse = 100
    //   this.percentageProposals = 100
    //   this.percentageAcquired = 100
    // },
    returnOnPaidInvestmentFull (cr) {
      // return Math.round(((this.netRevenue - this.costPerSale ) / this.costPerSale) * 100)
      let cps = ((this.adSpend / this.costPerClick) * (cr / 100)) * (this.percentageResponse / 100) * (this.percentageProposals / 100) * (this.percentageAcquired / 100)

      let leads = (this.adSpend / this.costPerClick) * (cr / 100)
      let ql = leads * (this.percentageResponse / 100)
      let pp = ql * (this.percentageProposals / 100)
      let pa = pp * (this.percentageAcquired / 100)

      let cps2 = ((this.adSpend / pa))

      console.log('adspend: ' + this.adSpend)

      console.log('cps ' + cps)
      console.log('cps2 ' + cps2)
      console.log('pa ' + pa)
      console.log('leads ' + leads)
      console.log('netrevenue ' + this.netRevenue)
      console.log('percentResp: ' + this.percentageResponse)
      console.log('percentProp: ' + this.percentageProposals)
      console.log('percentAcquir: ' + this.percentageAcquired)
      console.log('this profit: ' + this.profit)

      return Math.round(cps2)
    }
  }

}
</script>

<style scoped>

.ppc1 {
  background-color: #F5F5F5;
  /* font-family: "Averta","Arial","sans-serif" !important; */
}

body, button, input, select, textarea {
    font-family: "Averta","Arial","sans-serif"
}

.body.columns {
  font-family: "Averta","Arial","sans-serif";
}

#data-input {
  background-color: #FFF;
  /* font-family: "Averta","Arial","sans-serif" !important ; */
}
.tile.is-ancestor:last-child {
    margin-top: 0.75rem;
}
.highlightGreen {
  background-color: #75BC7F;
}
.highlightRed {
  background-color: #7C0435;
  color: #fff;
}
/**
 * Tooltip Styles
 */

/* Base styles for the element that has a tooltip */
[data-tooltip],
.tooltip {
  position: relative;
  cursor: pointer;
}

/* Base styles for the entire tooltip */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after {
  position: absolute;
  visibility: hidden;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
  opacity: 0;
  -webkit-transition:
	  opacity 0.2s ease-in-out,
		visibility 0.2s ease-in-out,
		-webkit-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
	-moz-transition:
		opacity 0.2s ease-in-out,
		visibility 0.2s ease-in-out,
		-moz-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
	transition:
		opacity 0.2s ease-in-out,
		visibility 0.2s ease-in-out,
		transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform:    translate3d(0, 0, 0);
  transform:         translate3d(0, 0, 0);
  pointer-events: none;
}

/* Show the entire tooltip on hover and focus */
[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after {
  visibility: visible;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
  opacity: 1;
}

/* Base styles for the tooltip's directional arrow */
.tooltip:before,
[data-tooltip]:before {
  z-index: 1001;
  border: 6px solid transparent;
  background: transparent;
  content: "";
}

/* Base styles for the tooltip's content area */
.tooltip:after,
[data-tooltip]:after {
  z-index: 1000;
  padding: 8px;
  width: 160px;
  background-color: #000;
  background-color: hsla(0, 0%, 20%, 0.9);
  color: #fff;
  content: attr(data-tooltip);
  font-size: 14px;
  line-height: 1.2;
}

/* Directions */

/* Top (default) */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after,
.tooltip-top:before,
.tooltip-top:after {
  bottom: 100%;
  left: 50%;
}

[data-tooltip]:before,
.tooltip:before,
.tooltip-top:before {
  margin-left: -6px;
  margin-bottom: -12px;
  border-top-color: #000;
  border-top-color: hsla(0, 0%, 20%, 0.9);
}

/* Horizontally align top/bottom tooltips */
[data-tooltip]:after,
.tooltip:after,
.tooltip-top:after {
  margin-left: -80px;
}

[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after,
.tooltip-top:hover:before,
.tooltip-top:hover:after,
.tooltip-top:focus:before,
.tooltip-top:focus:after {
  -webkit-transform: translateY(-12px);
  -moz-transform:    translateY(-12px);
  transform:         translateY(-12px);
}

/* Left */
.tooltip-left:before,
.tooltip-left:after {
  right: 100%;
  bottom: 50%;
  left: auto;
}

.tooltip-left:before {
  margin-left: 0;
  margin-right: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-left-color: #000;
  border-left-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-left:hover:before,
.tooltip-left:hover:after,
.tooltip-left:focus:before,
.tooltip-left:focus:after {
  -webkit-transform: translateX(-12px);
  -moz-transform:    translateX(-12px);
  transform:         translateX(-12px);
}

/* Bottom */
.tooltip-bottom:before,
.tooltip-bottom:after {
  top: 100%;
  bottom: auto;
  left: 50%;
}

.tooltip-bottom:before {
  margin-top: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-bottom-color: #000;
  border-bottom-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-bottom:hover:before,
.tooltip-bottom:hover:after,
.tooltip-bottom:focus:before,
.tooltip-bottom:focus:after {
  -webkit-transform: translateY(12px);
  -moz-transform:    translateY(12px);
  transform:         translateY(12px);
}

/* Right */
.tooltip-right:before,
.tooltip-right:after {
  bottom: 50%;
  left: 100%;
}

.tooltip-right:before {
  margin-bottom: 0;
  margin-left: -12px;
  border-top-color: transparent;
  border-right-color: #000;
  border-right-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-right:hover:before,
.tooltip-right:hover:after,
.tooltip-right:focus:before,
.tooltip-right:focus:after {
  -webkit-transform: translateX(12px);
  -moz-transform:    translateX(12px);
  transform:         translateX(12px);
}

/* Move directional arrows down a bit for left/right tooltips */
.tooltip-left:before,
.tooltip-right:before {
  top: 3px;
}

/* Vertically center tooltip content for left/right tooltips */
.tooltip-left:after,
.tooltip-right:after {
  margin-left: 0;
  margin-bottom: -16px;
}


</style>
